import { render } from "./BaseBreadcrumb.vue?vue&type=template&id=dfe04022&scoped=true"
import script from "./BaseBreadcrumb.vue?vue&type=script&lang=js"
export * from "./BaseBreadcrumb.vue?vue&type=script&lang=js"

import "./BaseBreadcrumb.vue?vue&type=style&index=0&id=dfe04022&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfe04022"]])

export default __exports__